<template>
  <el-row :gutter="15" class="wrapper">
    <el-col :md="6">
      <div class="card section">
        <p class="page-title">待审核服装制单数</p>
        <div class="content">
          <div class="item">
            <bean-link :to="{ name: 'product_designs.index', query: { state_in: ['pending'] } }">
              <p class="value">{{ data.product_designs_pending_count }}</p>
            </bean-link>
          </div>
        </div>
      </div>
    </el-col>
    <el-col :md="6">
      <div class="card section">
        <p class="page-title">制作中服装制单数</p>
        <div class="content">
          <div class="item">
            <bean-link :to="{ name: 'product_designs.index', query: { state_in: ['making'] } }">
              <p class="value">{{ data.product_designs_making_count }}</p>
            </bean-link>
          </div>
        </div>
      </div>
    </el-col>
    <el-col :md="6">
      <div class="card section">
        <p class="page-title">服装制单数</p>
        <div class="content">
          <div class="item">
            <bean-link :to="{ name: 'product_designs.index'}">
              <p class="value">{{ data.product_designs_count }}</p>
            </bean-link>
          </div>
        </div>
      </div>
    </el-col>
  </el-row>
</template>

<script>
import { Vue, Component } from 'vue-property-decorator';

@Component
export default class DesignerHome extends Vue {
  data = {
    product_designs_pending_count: 0,
    product_designs_wait_confirm_count: 0,
    product_designs_making_count: 0,
    product_designs_count: 0
  };

  async mounted() {
    this.data = await this.$request.get('/dashboard/designer_role')
  }
}
</script>
